import JSZip from "jszip";

export interface ZipItem {
	blob: Blob;
	filename: string;
}

/**
 * shironukiya_YYYYMMDD_HHMMSS.zip 形式のファイル名を生成する
 */
export function generateZipFilename(): string {
	const now = new Date();
	const pad = (n: number) => String(n).padStart(2, "0");
	const date = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}`;
	const time = `${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;
	return `shironukiya_${date}_${time}.zip`;
}

/**
 * 複数の画像BlobからZIPファイルを生成する
 */
export async function createBatchZip(items: ZipItem[]): Promise<Blob> {
	const zip = new JSZip();
	for (const { blob, filename } of items) {
		zip.file(filename, blob);
	}
	return zip.generateAsync({ type: "blob" });
}
